module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Etho","short_name":"Etho","start_url":"/","background_color":"#ffffff","theme_color":"#a2466c","display":"standalone","icon":"src/images/favicon.png"},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Etho","short_name":"Etho","start_url":"/","background_color":"#ffffff","theme_color":"#a2466c","display":"minimal-ui","icon":"src/images/favicon.png"},
    },{
      plugin: require('../node_modules/@sentry/gatsby/gatsby-browser.js'),
      options: {"plugins":[],"dsn":"https://435de864ead94ba7b78966a52fdf18fc@o372091.ingest.sentry.io/5189312","environment":"production"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
